// extracted by mini-css-extract-plugin
module.exports = {"summary":"_2xae_MWrsGYRvoKY3cZyNd","summaryContent":"_2MPBMIIvZew2Moa4aAHpOq"};